// Generated campaign scenes never replace the original catalogue photographs.
export const campaignScenes = [
  ['01-familia-flor', 'Família à mesa com a Flor Cítrica'],
  ['02-macro-beijo', 'Beijo de Coco: cobertura, coco e morangos'],
  ['03-doces-em-familia', 'Três gerações a partilhar mini-tarteletes'],
  ['04-macro-doces', 'Mini-tarteletes em grande plano'],
  ['05-salgados-partilha', 'Amigos a partilhar croquetes à mesa'],
  ['06-macro-salgados', 'Croquetes dourados em grande plano']
];

export function campaignSource(at,wide=false){
  // Telemóvel: 1200px chegam para 390px a 3x e poupam cerca de 40% por imagem.
  if(globalThis.LarrysaShopifyConfig?.campaigns){const src=globalThis.LarrysaShopifyConfig.campaigns[at];return matchMedia('(max-width:700px)').matches&&src&&!/[?&]width=/.test(src)?src+(src.includes('?')?'&':'?')+'width=1200':src;}
  return new URL(`${wide?'./social-scene/assets/campaign-wide/':'./media/campaign-20261017/'}${campaignScenes[at][0]}.webp`,import.meta.url).href;
}

export function campaignMarkup(src) {
  return `<figure class="campaign-photograph"><img id="campaign-image" width="1672" height="941" alt="Família à mesa com a Flor Cítrica · imagem de campanha gerada" src="${src}" fetchpriority="high" decoding="async"><img class="campaign-next" width="1672" height="941" alt="" aria-hidden="true"><figcaption class="campaign-label">Larrysa's Bakery · Pontinha</figcaption></figure>
    <div class="campaign-copy"><div><p>Pastelaria caseira · Pontinha</p><h1>Bolos, salgados e sobremesas</h1></div><div class="campaign-actions"><a href="/pages/menu" class="primary" data-entrance-menu>Ver a montra <span aria-hidden="true">→</span></a><a href="/pages/bakery-contactos" class="text-button" data-entrance-help>Dúvidas? Fale connosco</a></div></div>
    `;
}

export function mountCampaign(board, api) {
  const params=new URLSearchParams(location.search),wide=!!window.LarrysaShopifyConfig||params.get('social')==='1'&&params.get('enquadramento')==='panorama';
  if(wide)document.body.dataset.campaignFormat='panorama';
  const heading = document.createElement('header'); heading.className = 'shop-menu-heading';
  heading.innerHTML = '<h2 class="lh-h1">A nossa montra</h2>';
  const compare = document.querySelector('.montra-compare-btn'); compare.textContent = 'Comparar 2'; compare.setAttribute('aria-label','Comparar dois produtos');
  heading.append(compare);
  document.querySelector('.drawer-header').append(heading);
  document.querySelector('.header-whatsapp > span').textContent = 'O seu pedido';
  const back = document.querySelector('.cp-footer-links [data-panel-view="menu"]');
  back.textContent = 'Voltar à montra';
  back.onclick = e => {e.stopPropagation();document.querySelector('#cp-close').click();};
  board.className = 'campaign-board';
  board.setAttribute('aria-label', 'Vida à mesa · campanha ilustrativa');
  if (!board.querySelector('#campaign-image')) board.innerHTML = campaignMarkup(campaignSource(0,wide));
  const image = board.querySelector('img');
  const incoming = board.querySelector('.campaign-next');
  // Pause lives with the environment settings, leaving the physical display clear.
  const pause = document.createElement('button');
  pause.type = 'button'; pause.className = 'sound-toggle-btn'; pause.dataset.campaignPause = '';
  pause.setAttribute('aria-label', 'Pausar a alternância das imagens do ecrã');
  document.querySelector('.visit-settings .preview-left').append(pause);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let index = 0, paused = reduced.matches, failed = false, busy = false, transition;
  const paintPause = () => {
    pause.textContent = paused ? 'Ecrã: pausado' : 'Ecrã: automático';
    pause.setAttribute('aria-pressed', String(paused));
  };
  const description = at => `${campaignScenes[at][1]} · imagem de campanha gerada`;
  const source = at => campaignSource(at,wide);
  image.removeAttribute('srcset'); image.removeAttribute('sizes'); // o servidor já escolheu o tamanho; a rotação usa só src
  image.src = source(0); image.alt = description(0); board.dataset.scene = '0';
  pause.onclick = () => { paused = !paused; if (paused) transition?.cancel(); paintPause(); };
  reduced.addEventListener('change', () => {
    if (reduced.matches) { paused = true; transition?.cancel(); paintPause(); }
  });
  image.onerror = () => {
    if (failed) return;
    failed = true; paused = true; paintPause();
    image.src = api.getProduct('flor-citrica').originalImageResolved;
    image.alt = 'Flor Cítrica · fotografia original';
  };
  paintPause();
  incoming.fetchPriority='low';
  const primeNext=()=>{if(!failed&&!reduced.matches)incoming.src=source((index+1)%campaignScenes.length);};
  image.addEventListener('load',primeNext);if(image.complete)primeNext();
  // Decode the next scene before its short dissolve. Food and text never pan or zoom.
  const timer = setInterval(async () => {
    const blocked = () => paused || document.hidden || board.inert || board.contains(document.activeElement);
    if (busy || blocked()) return;
    busy = true;
    const next = (index + 1) % campaignScenes.length;
    try {
      incoming.src = source(next); await incoming.decode();
      if (blocked()) return;
      if (!reduced.matches) {
        transition = incoming.animate([{opacity:0},{opacity:1}], {duration:200,easing:'ease-out',fill:'both'});
        await transition.finished;
      }
      image.src = incoming.src; image.alt = description(next);
      index = next; board.dataset.scene = String(index);
    } catch (error) {
      if (error.name !== 'AbortError') { paused = true; paintPause(); }
    } finally { transition?.cancel(); transition = null; busy = false; primeNext(); }
  }, 3500);
  addEventListener('pagehide', event => { if (!event.persisted) clearInterval(timer); transition?.cancel(); });
}
